import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isReplyOptionDirty(state) {
    var savedOptions = state.userOptions;
    var replyAllByDefault = getFallbackValueIfNull(state.optionState.replyAllByDefault, savedOptions.IsReplyAllTheDefaultResponse);
    return replyAllByDefault !== savedOptions.IsReplyAllTheDefaultResponse;
});
//# sourceMappingURL=isReplyOptionDirty.js.map